export const isRouteMatch = (
	currentRoute: string,
	routeMatch?: RegExp | string,
) => {
	if (!routeMatch) return false;
	return routeMatch instanceof RegExp
		? routeMatch.test(currentRoute)
		: currentRoute.includes(routeMatch);
};
